import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { ReactNode } from "react";
import { FacturaInforme } from "../Informes";
import { formatCurrency } from "../../../../utils/Factura";

interface KPIsFacturacionProps {
  facturas: FacturaInforme[];
}

const sumarTotal = (items: FacturaInforme[]): number =>
  items.reduce((acc, f) => acc + f.total, 0);

const KPIsFacturacion = ({ facturas }: KPIsFacturacionProps) => {

  const moneda = facturas[0]?.moneda || 'EUR';

  const ingresos = sumarTotal(facturas.filter(f => f.estadoPago === 'Pagada'));
  const pendientes = sumarTotal(facturas.filter(f => f.estadoPago === 'Pendiente'));

  // Las anulaciones (la negativa) no son facturas creadas; la original anulada sí se emitió.
  const facturasPropias = facturas.filter(f => f.tipoRectificacion !== 'anulacion');
  const numFacturasEmitidas = facturasPropias.filter(f => f.estado !== 'Borrador').length;
  const numFacturasCreadas = facturasPropias.length;

  const porcentajeEmitidas = numFacturasCreadas
    ? Math.round((numFacturasEmitidas / numFacturasCreadas) * 100)
    : 0;

  const numPacientesFacturados = new Set(
    facturas.map(f => f.paciente)
  ).size;

  const metrics: { label: string; value: ReactNode; color: string }[] = [
    {
      label: 'Ingresos totales',
      value: formatCurrency(ingresos, moneda),
      color: 'success.main'
    },
    {
      label: 'Pendientes de cobro',
      value: formatCurrency(pendientes, moneda),
      color: 'error.main'
    },
    {
      label: 'Ratio de emisión',
      value: `${porcentajeEmitidas}%`,
      color: 'info.main'
    },
    {
      label: 'Pacientes facturados',
      value: numPacientesFacturados,
      color: 'secondary.main'
    }
  ];

  return (
    <Box mt={3}>
      <Grid container spacing={3}>
        {metrics.map((metric) => (
          <Grid item xs={12} sm={6} md={3} key={metric.label}>
            <Card sx={{ height: '100%' }}>
              <CardContent
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                <Box>
                  <Box display="flex" alignItems="center" gap={1}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: metric.color,
                      }}
                    />
                    <Typography variant="subtitle2">
                      {metric.label}
                    </Typography>
                  </Box>

                  {typeof metric.value === 'string' || typeof metric.value === 'number' ? (
                    <Typography variant="h4" fontWeight={700}>
                      {metric.value}
                    </Typography>
                  ) : (
                    <Box mt={0.5}>{metric.value}</Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default KPIsFacturacion;
